import React, { memo } from "react";
import { useNavigate } from "react-router-dom";
import { Card, ProgressBar } from "react-bootstrap";

const IncentiveCard = memo(function IncentiveCard({
  title,
  type,
  earned,
  potential,
  progress,
  summaryInfo,
  variant = "primary",
  dateFrom,
  dateTo,
}) {
  const navigate = useNavigate();
  const progressPct = typeof progress === "number" ? Math.min(100, Math.max(0, progress)) : 0;
  const search = [dateFrom && `date_from=${encodeURIComponent(dateFrom)}`, dateTo && `date_to=${encodeURIComponent(dateTo)}`].filter(Boolean).join("&");
  const handleClick = () => navigate(`/incentives/${type}${search ? `?${search}` : ""}`);

  return (
    <Card
      className="h-100 shadow-sm border-0 cursor-pointer"
      style={{ cursor: "pointer", minHeight: "200px" }}
      onClick={handleClick}
    >
      <Card.Body className="d-flex flex-column">
        <Card.Title className="text-capitalize mb-3">{title}</Card.Title>
        <div className="mb-2">
          <small className="text-muted">Earned</small>
          <div className="fw-semibold">
            {typeof earned === "number" ? earned.toLocaleString(undefined, { minimumFractionDigits: 2 }) : earned}
          </div>
        </div>
        <div className="mb-2">
          <small className="text-muted">Potential</small>
          <div className="fw-semibold">
            {typeof potential === "number" ? potential.toLocaleString(undefined, { minimumFractionDigits: 2 }) : potential}
          </div>
        </div>
        <div className="mt-auto">
          <div className="d-flex justify-content-between small mb-1">
            <span>Progress</span>
            <span>{progressPct.toFixed(1)}%</span>
          </div>
          <ProgressBar
            now={progressPct}
            variant={variant}
            style={{ height: "8px" }}
          />
        </div>
        {summaryInfo && (
          <div className="mt-2 small text-muted">{summaryInfo}</div>
        )}
      </Card.Body>
    </Card>
  );
});

export default IncentiveCard;
